import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SharedService } from '../shared-service/shared.service';
import { StorageService } from '../storage/storage.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export interface UserData {
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  companyName?: string;
  country?: string;
  county?: string;
  emailAddress?: string;
  externalRef?: string;
  forename?: string;
  outbidEmailsOk?: boolean;
  phoneNumber?: string;
  postcode?: string;
  surname?: string;
  username?: string;
  error?: string;
}

@Injectable({
  providedIn: 'root',
})
export class UserService {

  public userDataListener: Subject<Partial<UserData>> = new Subject();

  private $userData: Partial<UserData> | undefined;

  private userDataRequestDebounce:any;
  constructor(
    private Shared: SharedService,
    private Storage: StorageService,
    private Http: HttpClient,
  ) {
    this.Shared.signOutListener.subscribe(() => {
      this.$userData = undefined;
    });
  }

  private getHeaders(includeAuth = true): HttpHeaders {
    const accessToken = this.Storage.get('access_token');
    let headers = new HttpHeaders()
      .set('content-type', 'application/json')
      .set('x-forwarded-client-id', 'machineric');
    
    if (includeAuth) {
      headers = headers.set('Authorization', `Bearer ${accessToken}`);
    }
    return headers;

  }

  public getUserData(emptyCache:boolean = false) {
    return new Observable<UserData>((observer) => {
      const accessToken = this.Storage.get('access_token');
      if (!accessToken) {
        observer.next({
          error: 'No access token',
        });
      }
      else if (this.$userData && !emptyCache) {
        observer.next(this.$userData);
      } else {
        const headers = this.getHeaders();
        clearTimeout(this.userDataRequestDebounce);
        this.userDataRequestDebounce = setTimeout(() => {
          this.Http.get(`${environment.api}/users/bidderdata`, {
            headers
          }).subscribe({
            next: (response) => {
              this.$userData = response;
              this.userDataListener.next(response);
              observer.next(response);
              observer.complete();
            },
            error: (err) => {
              observer.next({
                error: 'Authentication error',
              })
            }
          })
        }, 300)
      }
    });
  }
}
